import React from 'react';
import PropTypes from 'prop-types';

let timezone;

if (Intl) {
  const resolvedOptionsTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  if (resolvedOptionsTimezone) {
    timezone = resolvedOptionsTimezone.replace('/', ', ');
  }
} else {
  const now = new Date();
  const timezoneOffset = now.getTimezoneOffset() / -60;

  timezone = `GMT${timezoneOffset >= 0 ? '+' : ''}${timezoneOffset}`;
}


export default class CurrentTimezone extends React.PureComponent {
  render() {
    return timezone;
  }
}



// WEBPACK FOOTER //
// ./components/dates/CurrentTimezone.js